import { Injectable } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { ICRUDOptions } from '@phx-erp/shared';
import { BaseListService } from "../../../@core/services/base-list.service";
import { SystemService } from "../../../@core/services/system.service";
import { DELETE_BANK, GET_BANK, GET_BANKS, SAVE_BANK } from "../../../data/definitions/bank.definition";
import { BaseDataService } from "../../../data/services/base-data.service";
import { DataService } from "../../../data/services/data.service";
import { Bank, BankInput, DeleteBankMutation, DeleteBankMutationVariables, DeletionResponse, GetBankQuery, GetBankQueryVariables, GetBanksQuery, GetBanksQueryVariables, SaveBankMutation, SaveBankMutationVariables, SearchInput } from "../../../generated/generated-types";

@Injectable({
  providedIn: 'root'
})
export class BankService extends BaseListService<Bank> {

  constructor(private dataService: DataService,
    private baseDataService: BaseDataService,
    private systemService: SystemService) {
    super();
  }
  //#region implementation
  getItems(searchInput?: SearchInput, o?: ICRUDOptions) {

    let fragment = GET_BANKS;

    if (o?.currentColumnConfig) {
      this.onlyKeepSelectedGraphQLNodesNew(fragment, o.currentColumnConfig.baseView, o.currentColumnConfig.columns);
    }

    return this.baseDataService.query<GetBanksQuery, GetBanksQueryVariables>(
      fragment, {
      input: searchInput as any
    });
  }

  getItem(id: string) {

    return this.baseDataService.query<GetBankQuery, GetBankQueryVariables>(
      GET_BANK, {
      id: id
    });
  }

  getItemStream(id: string) {
    return this.getItem(id).mapStream(x => x.getBank);
  }

  async getItemData(id: string): Promise<Bank> {
    let l = await lastValueFrom(this.getItem(id).single$);
    return l.getBank as Bank;
  }

  async deleteItem(id: string): Promise<DeletionResponse> {
    let res = await lastValueFrom(this.baseDataService.mutate<DeleteBankMutation, DeleteBankMutationVariables>(
      DELETE_BANK, {
      id: id
    }));

    return res.deleteBank
  }

  async saveItem(bank: Bank | BankInput) {

    let validated = await this.systemService.validateObject<BankInput>(bank, "BankInput");

    let saved = await lastValueFrom(this.baseDataService.mutate<SaveBankMutation, SaveBankMutationVariables>(
      SAVE_BANK, {
      input: validated
    }));

    return saved.saveBank as Bank;
  }
  //#endregion

}
